// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    AlternatePackagingModel,
    AlternatePackagingRequestModel,
    AttributeTypeModel,
} from "@insite/client-framework/Types/ApiModels";

export interface GetAlternatePackagingApiParameter extends ApiParameter {
    id?: string;
    productErpNumber: string;
    superAndSubCategories: string;
    attributeTypes: AttributeTypeModel[];
}

export interface SendAlternatePackagingRequestApiParameter extends ApiParameter {
    recommendedProductRequestModel: AlternatePackagingRequestModel;
}

const baseUrl = "/api/v1/custom/alternatepackaging";

export async function getAlternatePackaging(
    parameter: GetAlternatePackagingApiParameter,
): Promise<ServiceResult<AlternatePackagingModel>> {
    try {
        const alternatePackaging = await post<AlternatePackagingModel>(baseUrl, parameter);
        return {
            successful: true,
            result: alternatePackaging,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || error.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function sendAlternativePackagingRequest(
    parameter: SendAlternatePackagingRequestApiParameter,
): Promise<ServiceResult<AlternatePackagingRequestModel>> {
    try {
        const alternatePackagingRequest = await post<AlternatePackagingRequestModel>(
            `${baseUrl}/sendrequest`,
            parameter.recommendedProductRequestModel,
        );
        return {
            successful: true,
            result: alternatePackagingRequest,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
